import { render, staticRenderFns } from "./WritingData.vue?vue&type=template&id=0265cfe2&scoped=true"
import script from "./WritingData.vue?vue&type=script&lang=ts"
export * from "./WritingData.vue?vue&type=script&lang=ts"
import style0 from "./WritingData.vue?vue&type=style&index=0&id=0265cfe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0265cfe2",
  null
  
)

export default component.exports